var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowNarrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/arrow-narrow-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7357 10.9348C13.9046 11.0931 13.9995 11.3076 13.9995 11.5314C13.9995 11.7551 13.9046 11.9697 13.7357 12.1279L10.1312 15.503C9.96218 15.6611 9.73302 15.75 9.49407 15.75C9.25512 15.75 9.02596 15.6611 8.85698 15.503L5.25247 12.1279C5.08832 11.9688 4.99749 11.7556 4.99955 11.5344C5.0016 11.3132 5.09637 11.1016 5.26345 10.9451C5.43052 10.7887 5.65654 10.6999 5.89281 10.698C6.12908 10.6961 6.35671 10.7811 6.52666 10.9348L8.59295 12.8696L8.59295 3.09376C8.59295 2.86998 8.68789 2.65537 8.85688 2.49713C9.02587 2.3389 9.25508 2.25 9.49407 2.25C9.73307 2.25 9.96227 2.3389 10.1313 2.49713C10.3003 2.65537 10.3952 2.86998 10.3952 3.09376L10.3952 12.8696L12.4615 10.9348C12.6305 10.7767 12.8596 10.6878 13.0986 10.6878C13.3375 10.6878 13.5667 10.7767 13.7357 10.9348Z",
    fill: "#616D8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowDown);
export default __webpack_public_path__ + "static/media/arrow-narrow-down.bf28f3c85faef3b45eb38f763c618566.svg";
export { ForwardRef as ReactComponent };